import { logger } from '@automata/utils';

import { LabwareType } from '../types';

export const COLORS = [
  '#3E7DD6', // blue
  '#89E0CB', // turquoise
  '#A9CE00', // Chartreuse
  '#FFC94B', // yellow
  '#F98F00', // orange
  '#F581ED', // lilac
  '#B03D8D', // magenta
  '#626262', // gray
  '#182D4D', // slate
] as const;

export function getColorFromIndex(index: number): string {
  const FALLBACK_COLOR = 'red';
  const color = COLORS[index];
  if (color === undefined) {
    logger.error('bad index for color', index);
    return FALLBACK_COLOR;
  }
  return color;
}

export const LABWARE_TYPE_DEFAULT_COLOR: Record<LabwareType, number> = {
  microplate: 0,
  reservoir: 1,
  tuberack: 2,
  tiprack: 3,
} as const;

/** use default for labware type if none is specified in nodeIdToColorIndex */
export function getLabwareColorIndex({
  id,
  nodeIdToColorIndex,
  labwareType,
}: {
  id: string;
  nodeIdToColorIndex: { [labwareId: string]: number };
  labwareType?: LabwareType | null | undefined;
}): number {
  if (labwareType === null || labwareType === undefined) {
    logger.warn(
      `could not get labware color index for ${id}, invalid/missing labwareType.`
    );
    return 0;
  }
  const colorIndex = nodeIdToColorIndex[id];
  return colorIndex === undefined
    ? LABWARE_TYPE_DEFAULT_COLOR[labwareType]
    : colorIndex;
}
